import React, { useState } from 'react';

// ============================================
// NURSE RESUME BY AUTOHIREBOT
// India's First AI-Powered Resume Builder for Nursing Professionals
// Version 2.0 - All Issues Fixed
// ============================================

// ============================================
// CONFIGURATION & DATA
// ============================================

const QUALIFICATIONS = [
  { id: 'gnm', name: 'GNM (General Nursing & Midwifery)', duration: '3.5 Years' },
  { id: 'bsc', name: 'B.Sc Nursing', duration: '4 Years' },
  { id: 'anm', name: 'ANM (Auxiliary Nurse Midwife)', duration: '2 Years' },
  { id: 'msc', name: 'M.Sc Nursing', duration: '2 Years' },
  { id: 'pbsc', name: 'Post Basic B.Sc Nursing', duration: '2 Years' },
  { id: 'npcc', name: 'Nursing (NP/CC)', duration: '2 Years' },
];

const CERTIFICATIONS = [
  { id: 'bls', name: 'BLS (Basic Life Support)', icon: '❤️' },
  { id: 'acls', name: 'ACLS (Advanced Cardiac Life Support)', icon: '💓' },
  { id: 'pals', name: 'PALS (Pediatric Advanced Life Support)', icon: '👶' },
  { id: 'nals', name: 'NALS (Neonatal Advanced Life Support)', icon: '🍼' },
  { id: 'ccrn', name: 'CCRN (Critical Care Registered Nurse)', icon: '🏥' },
  { id: 'infection', name: 'Infection Control Certification', icon: '🦠' },
  { id: 'wound', name: 'Wound Care Certification', icon: '🩹' },
  { id: 'dialysis', name: 'Dialysis Technician', icon: '💉' },
  { id: 'oncology', name: 'Oncology Nursing Certification', icon: '🎗️' },
  { id: 'icu', name: 'ICU/CCU Specialized Training', icon: '🫀' },
];

const CLINICAL_DEPARTMENTS = [
  'Medical Ward', 'Surgical Ward', 'ICU/CCU', 'Emergency/Trauma',
  'Operation Theatre', 'Labor Room', 'Pediatrics', 'Neonatal ICU',
  'Oncology', 'Orthopedics', 'Cardiology', 'Neurology',
  'Dialysis Unit', 'Burn Unit', 'Psychiatry', 'Community Health',
  'Outpatient Department', 'Endoscopy', 'Cath Lab', 'Transplant Unit'
];

const NURSING_SKILLS = [
  'Patient Assessment', 'Vital Signs Monitoring', 'IV Cannulation',
  'Blood Sample Collection', 'Medication Administration', 'Wound Dressing',
  'Catheterization', 'NG Tube Insertion', 'Tracheostomy Care',
  'Ventilator Management', 'ECG Monitoring', 'Oxygen Therapy',
  'CPR/BLS', 'Patient Counseling', 'Health Education',
  'Documentation & Charting', 'Infection Control', 'Pain Management',
  'Post-operative Care', 'Pre-operative Preparation', 'Emergency Response',
  'Diabetic Care', 'Pediatric Care', 'Geriatric Care',
  'Palliative Care', 'Blood Transfusion', 'Chemotherapy Administration'
];

const INDIAN_STATES = [
  'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
  'Delhi', 'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand',
  'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur',
  'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 'Rajasthan',
  'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh',
  'Uttarakhand', 'West Bengal'
];

const HOSPITAL_TYPES = [
  'Government Hospital', 'Private Hospital', 'Corporate Hospital Chain',
  'Nursing Home', 'Primary Health Center', 'Community Health Center',
  'Medical College Hospital', 'Super Specialty Hospital', 'Trust Hospital',
  'Army/Defense Hospital', 'Railway Hospital', 'ESI Hospital'
];

// ============================================
// ICONS COMPONENT
// ============================================

const Icons = {
  User: () => (
    <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
    </svg>
  ),
  Education: () => (
    <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 14l9-5-9-5-9 5 9 5z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
    </svg>
  ),
  Briefcase: () => (
    <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
  ),
  Certificate: () => (
    <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
    </svg>
  ),
  Skills: () => (
    <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
    </svg>
  ),
  Clinical: () => (
    <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
    </svg>
  ),
  Download: () => (
    <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
    </svg>
  ),
  Check: () => (
    <svg className="icon-sm" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
    </svg>
  ),
  Plus: () => (
    <svg className="icon-sm" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
    </svg>
  ),
  Trash: () => (
    <svg className="icon-sm" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
    </svg>
  ),
  Phone: () => (
    <svg className="icon-xs" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
    </svg>
  ),
  Mail: () => (
    <svg className="icon-xs" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
  ),
  Location: () => (
    <svg className="icon-xs" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  ),
  Sparkles: () => (
    <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
    </svg>
  ),
  ArrowRight: () => (
    <svg className="icon-sm" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
    </svg>
  ),
  ArrowLeft: () => (
    <svg className="icon-sm" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
    </svg>
  ),
  Eye: () => (
    <svg className="icon-sm" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
    </svg>
  ),
};

// ============================================
// INITIAL STATE
// ============================================

const initialResumeData = {
  personal: {
    fullName: '',
    photo: null,
    email: '',
    phone: '',
    altPhone: '',
    address: '',
    city: '',
    state: '',
    pincode: '',
    dateOfBirth: '',
    gender: '',
    maritalStatus: '',
    linkedIn: '',
  },
  summary: '',
  education: [{
    id: Date.now(),
    qualification: '',
    institution: '',
    university: '',
    year: '',
    percentage: '',
    specialization: '',
  }],
  registration: {
    councilName: '',
    councilState: '',
    registrationNumber: '',
    validFrom: '',
    validTill: '',
  },
  experience: [],
  clinicalRotations: [],
  certifications: [],
  skills: [],
  languages: [
    { id: 1, name: 'English', proficiency: 'Fluent' },
    { id: 2, name: 'Hindi', proficiency: 'Native' },
  ],
  references: [],
  template: 'professional',
};

// ============================================
// STEP INDICATOR COMPONENT
// ============================================

const StepIndicator = ({ currentStep, steps, onStepClick }) => {
  return (
    <div className="step-indicator">
      {steps.map((step, index) => (
        <div 
          key={step.id}
          className={`step-item ${index === currentStep ? 'active' : ''} ${index < currentStep ? 'completed' : ''}`}
          onClick={() => index <= currentStep && onStepClick(index)}
        >
          <div className="step-circle">
            {index < currentStep ? <Icons.Check /> : <span>{index + 1}</span>}
          </div>
          <span className="step-label">{step.label}</span>
          {index < steps.length - 1 && <div className="step-line" />}
        </div>
      ))}
    </div>
  );
};

// ============================================
// FORM COMPONENTS
// ============================================

const FormInput = ({ label, required, error, ...props }) => (
  <div className="form-group">
    {label && (
      <label className="form-label">
        {label} {required && <span className="required">*</span>}
      </label>
    )}
    <input className={`form-input ${error ? 'error' : ''}`} {...props} />
    {error && <span className="error-text">{error}</span>}
  </div>
);

const FormTextarea = ({ label, required, error, ...props }) => (
  <div className="form-group">
    {label && (
      <label className="form-label">
        {label} {required && <span className="required">*</span>}
      </label>
    )}
    <textarea className={`form-textarea ${error ? 'error' : ''}`} {...props} />
    {error && <span className="error-text">{error}</span>}
  </div>
);

const FormSelect = ({ label, required, options, error, ...props }) => (
  <div className="form-group">
    {label && (
      <label className="form-label">
        {label} {required && <span className="required">*</span>}
      </label>
    )}
    <select className={`form-select ${error ? 'error' : ''}`} {...props}>
      <option value="">Select...</option>
      {options.map(opt => (
        <option key={opt.value || opt} value={opt.value || opt}>
          {opt.label || opt}
        </option>
      ))}
    </select>
    {error && <span className="error-text">{error}</span>}
  </div>
);

// ============================================
// STEP 1: PERSONAL INFORMATION
// ============================================

const PersonalInfoStep = ({ data, onChange }) => {
  const handlePhotoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        onChange('personal', { ...data.personal, photo: reader.result });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleChange = (field, value) => {
    onChange('personal', { ...data.personal, [field]: value });
  };

  return (
    <div className="step-content">
      <div className="step-header">
        <div className="step-icon"><Icons.User /></div>
        <div>
          <h2>Personal Information</h2>
          <p>Let's start with your basic details</p>
        </div>
      </div>

      <div className="photo-upload-section">
        <div className="photo-preview">
          {data.personal.photo ? (
            <img src={data.personal.photo} alt="Profile" />
          ) : (
            <div className="photo-placeholder">
              <Icons.User />
              <span>Add Photo</span>
            </div>
          )}
        </div>
        <div className="photo-upload-info">
          <h4>Profile Photo</h4>
          <p>Upload a professional passport-size photo</p>
          <label className="btn btn-secondary btn-sm">
            <input 
              type="file" 
              accept="image/*" 
              onChange={handlePhotoUpload}
              style={{ display: 'none' }}
            />
            Choose Photo
          </label>
        </div>
      </div>

      <div className="form-grid">
        <FormInput
          label="Full Name"
          required
          placeholder="Enter your full name"
          value={data.personal.fullName}
          onChange={(e) => handleChange('fullName', e.target.value)}
        />
        <FormSelect
          label="Gender"
          required
          value={data.personal.gender}
          onChange={(e) => handleChange('gender', e.target.value)}
          options={['Male', 'Female', 'Other']}
        />
        <FormInput
          label="Date of Birth"
          type="date"
          value={data.personal.dateOfBirth}
          onChange={(e) => handleChange('dateOfBirth', e.target.value)}
        />
        <FormSelect
          label="Marital Status"
          value={data.personal.maritalStatus}
          onChange={(e) => handleChange('maritalStatus', e.target.value)}
          options={['Single', 'Married', 'Divorced', 'Widowed']}
        />
        <FormInput
          label="Email Address"
          required
          type="email"
          placeholder="your.email@example.com"
          value={data.personal.email}
          onChange={(e) => handleChange('email', e.target.value)}
        />
        <FormInput
          label="Mobile Number"
          required
          placeholder="+91 98765 43210"
          value={data.personal.phone}
          onChange={(e) => handleChange('phone', e.target.value)}
        />
        <FormInput
          label="Alternate Number"
          placeholder="+91 87654 32109"
          value={data.personal.altPhone}
          onChange={(e) => handleChange('altPhone', e.target.value)}
        />
        <FormInput
          label="LinkedIn Profile"
          placeholder="linkedin.com/in/yourprofile"
          value={data.personal.linkedIn}
          onChange={(e) => handleChange('linkedIn', e.target.value)}
        />
      </div>

      <div className="section-divider">
        <span>Address Details</span>
      </div>

      <div className="form-grid">
        <div className="form-group full-width">
          <FormTextarea
            label="Address"
            placeholder="Enter your complete address"
            rows={2}
            value={data.personal.address}
            onChange={(e) => handleChange('address', e.target.value)}
          />
        </div>
        <FormInput
          label="City"
          placeholder="City"
          value={data.personal.city}
          onChange={(e) => handleChange('city', e.target.value)}
        />
        <FormSelect
          label="State"
          value={data.personal.state}
          onChange={(e) => handleChange('state', e.target.value)}
          options={INDIAN_STATES}
        />
        <FormInput
          label="PIN Code"
          placeholder="500001"
          value={data.personal.pincode}
          onChange={(e) => handleChange('pincode', e.target.value)}
        />
      </div>
    </div>
  );
};

// ============================================
// STEP 2: EDUCATION
// ============================================

const EducationStep = ({ data, onChange }) => {
  const addEducation = () => {
    onChange('education', [...data.education, {
      id: Date.now(),
      qualification: '',
      institution: '',
      university: '',
      year: '',
      percentage: '',
      specialization: '',
    }]);
  };

  const updateEducation = (id, field, value) => {
    onChange('education', data.education.map(edu => 
      edu.id === id ? { ...edu, [field]: value } : edu
    ));
  };

  const removeEducation = (id) => {
    if (data.education.length > 1) {
      onChange('education', data.education.filter(edu => edu.id !== id));
    }
  };

  const handleRegistrationChange = (field, value) => {
    onChange('registration', { ...data.registration, [field]: value });
  };

  return (
    <div className="step-content">
      <div className="step-header">
        <div className="step-icon"><Icons.Education /></div>
        <div>
          <h2>Education & Registration</h2>
          <p>Add your nursing qualifications and council registration</p>
        </div>
      </div>

      {/* Nursing Council Registration */}
      <div className="highlight-card">
        <div className="highlight-card-header">
          <span className="badge badge-primary">Required</span>
          <h3>🏛️ Indian Nursing Council Registration</h3>
        </div>
        <div className="form-grid">
          <FormSelect
            label="State Nursing Council"
            required
            value={data.registration.councilState}
            onChange={(e) => handleRegistrationChange('councilState', e.target.value)}
            options={INDIAN_STATES.map(s => ({ value: s, label: `${s} Nursing Council` }))}
          />
          <FormInput
            label="Registration Number"
            required
            placeholder="e.g., TNMC-2020-12345"
            value={data.registration.registrationNumber}
            onChange={(e) => handleRegistrationChange('registrationNumber', e.target.value)}
          />
          <FormInput
            label="Valid From"
            type="date"
            value={data.registration.validFrom}
            onChange={(e) => handleRegistrationChange('validFrom', e.target.value)}
          />
          <FormInput
            label="Valid Till"
            type="date"
            value={data.registration.validTill}
            onChange={(e) => handleRegistrationChange('validTill', e.target.value)}
          />
        </div>
      </div>

      {/* Education List */}
      <div className="section-title">
        <h3>📚 Educational Qualifications</h3>
        <button className="btn btn-secondary btn-sm" onClick={addEducation}>
          <Icons.Plus /> Add More
        </button>
      </div>

      {data.education.map((edu, index) => (
        <div key={edu.id} className="card-item">
          <div className="card-item-header">
            <span className="card-item-number">{index + 1}</span>
            <h4>Qualification {index + 1}</h4>
            {data.education.length > 1 && (
              <button 
                className="btn-icon btn-danger"
                onClick={() => removeEducation(edu.id)}
              >
                <Icons.Trash />
              </button>
            )}
          </div>
          <div className="form-grid">
            <FormSelect
              label="Nursing Qualification"
              required
              value={edu.qualification}
              onChange={(e) => updateEducation(edu.id, 'qualification', e.target.value)}
              options={QUALIFICATIONS.map(q => ({ value: q.id, label: `${q.name} (${q.duration})` }))}
            />
            <FormInput
              label="Specialization (if any)"
              placeholder="e.g., Critical Care, Pediatrics"
              value={edu.specialization}
              onChange={(e) => updateEducation(edu.id, 'specialization', e.target.value)}
            />
            <FormInput
              label="Institution/College"
              required
              placeholder="Name of Nursing College"
              value={edu.institution}
              onChange={(e) => updateEducation(edu.id, 'institution', e.target.value)}
            />
            <FormInput
              label="University/Board"
              placeholder="Affiliated University"
              value={edu.university}
              onChange={(e) => updateEducation(edu.id, 'university', e.target.value)}
            />
            <FormInput
              label="Year of Passing"
              required
              placeholder="2024"
              value={edu.year}
              onChange={(e) => updateEducation(edu.id, 'year', e.target.value)}
            />
            <FormInput
              label="Percentage/CGPA"
              placeholder="75% or 8.5 CGPA"
              value={edu.percentage}
              onChange={(e) => updateEducation(edu.id, 'percentage', e.target.value)}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

// ============================================
// STEP 3: EXPERIENCE
// ============================================

const ExperienceStep = ({ data, onChange }) => {
  const [isFresher, setIsFresher] = useState(data.experience.length === 0);

  const addExperience = () => {
    onChange('experience', [...data.experience, {
      id: Date.now(),
      hospitalName: '',
      hospitalType: '',
      designation: '',
      department: '',
      location: '',
      startDate: '',
      endDate: '',
      currentlyWorking: false,
      responsibilities: '',
      achievements: '',
    }]);
    setIsFresher(false);
  };

  const updateExperience = (id, field, value) => {
    onChange('experience', data.experience.map(exp => 
      exp.id === id ? { ...exp, [field]: value } : exp
    ));
  };

  const removeExperience = (id) => {
    const updated = data.experience.filter(exp => exp.id !== id);
    onChange('experience', updated);
    if (updated.length === 0) setIsFresher(true);
  };

  const addClinicalRotation = () => {
    onChange('clinicalRotations', [...data.clinicalRotations, {
      id: Date.now(),
      department: '',
      duration: '',
      hospital: '',
      keyLearnings: '',
    }]);
  };

  const updateRotation = (id, field, value) => {
    onChange('clinicalRotations', data.clinicalRotations.map(rot => 
      rot.id === id ? { ...rot, [field]: value } : rot
    ));
  };

  const removeRotation = (id) => {
    onChange('clinicalRotations', data.clinicalRotations.filter(rot => rot.id !== id));
  };

  return (
    <div className="step-content">
      <div className="step-header">
        <div className="step-icon"><Icons.Briefcase /></div>
        <div>
          <h2>Work Experience</h2>
          <p>Add your nursing work experience or clinical rotations</p>
        </div>
      </div>

      {/* Experience Type Toggle */}
      <div className="toggle-section">
        <button 
          className={`toggle-btn ${!isFresher ? 'active' : ''}`}
          onClick={() => setIsFresher(false)}
        >
          👨‍⚕️ Experienced Nurse
        </button>
        <button 
          className={`toggle-btn ${isFresher ? 'active' : ''}`}
          onClick={() => setIsFresher(true)}
        >
          🎓 Fresher / Student
        </button>
      </div>

      {!isFresher ? (
        <>
          <div className="section-title">
            <h3>🏥 Work Experience</h3>
            <button className="btn btn-secondary btn-sm" onClick={addExperience}>
              <Icons.Plus /> Add Experience
            </button>
          </div>

          {data.experience.length === 0 ? (
            <div className="empty-state">
              <Icons.Briefcase />
              <p>No experience added yet</p>
              <button className="btn btn-primary btn-sm" onClick={addExperience}>
                Add Your First Experience
              </button>
            </div>
          ) : (
            data.experience.map((exp, index) => (
              <div key={exp.id} className="card-item">
                <div className="card-item-header">
                  <span className="card-item-number">{index + 1}</span>
                  <h4>{exp.hospitalName || `Experience ${index + 1}`}</h4>
                  <button 
                    className="btn-icon btn-danger"
                    onClick={() => removeExperience(exp.id)}
                  >
                    <Icons.Trash />
                  </button>
                </div>
                <div className="form-grid">
                  <FormInput
                    label="Hospital/Organization Name"
                    required
                    placeholder="e.g., Apollo Hospitals"
                    value={exp.hospitalName}
                    onChange={(e) => updateExperience(exp.id, 'hospitalName', e.target.value)}
                  />
                  <FormSelect
                    label="Hospital Type"
                    value={exp.hospitalType}
                    onChange={(e) => updateExperience(exp.id, 'hospitalType', e.target.value)}
                    options={HOSPITAL_TYPES}
                  />
                  <FormInput
                    label="Designation"
                    required
                    placeholder="e.g., Staff Nurse, Senior Nurse"
                    value={exp.designation}
                    onChange={(e) => updateExperience(exp.id, 'designation', e.target.value)}
                  />
                  <FormSelect
                    label="Department"
                    required
                    value={exp.department}
                    onChange={(e) => updateExperience(exp.id, 'department', e.target.value)}
                    options={CLINICAL_DEPARTMENTS}
                  />
                  <FormInput
                    label="Location"
                    placeholder="City, State"
                    value={exp.location}
                    onChange={(e) => updateExperience(exp.id, 'location', e.target.value)}
                  />
                  <div className="form-group">
                    <label className="form-label">Currently Working Here?</label>
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        checked={exp.currentlyWorking}
                        onChange={(e) => updateExperience(exp.id, 'currentlyWorking', e.target.checked)}
                      />
                      <span>Yes, I currently work here</span>
                    </label>
                  </div>
                  <FormInput
                    label="Start Date"
                    type="date"
                    value={exp.startDate}
                    onChange={(e) => updateExperience(exp.id, 'startDate', e.target.value)}
                  />
                  {!exp.currentlyWorking && (
                    <FormInput
                      label="End Date"
                      type="date"
                      value={exp.endDate}
                      onChange={(e) => updateExperience(exp.id, 'endDate', e.target.value)}
                    />
                  )}
                  <div className="form-group full-width">
                    <FormTextarea
                      label="Key Responsibilities"
                      placeholder="Describe your main duties and responsibilities..."
                      rows={3}
                      value={exp.responsibilities}
                      onChange={(e) => updateExperience(exp.id, 'responsibilities', e.target.value)}
                    />
                  </div>
                  <div className="form-group full-width">
                    <FormTextarea
                      label="Achievements (Optional)"
                      placeholder="Any notable achievements, awards, or recognitions..."
                      rows={2}
                      value={exp.achievements}
                      onChange={(e) => updateExperience(exp.id, 'achievements', e.target.value)}
                    />
                  </div>
                </div>
              </div>
            ))
          )}
        </>
      ) : (
        <>
          <div className="section-title">
            <h3>🩺 Clinical Rotations / Internship</h3>
            <button className="btn btn-secondary btn-sm" onClick={addClinicalRotation}>
              <Icons.Plus /> Add Rotation
            </button>
          </div>

          <div className="info-banner">
            <span className="info-icon">💡</span>
            <p>As a fresher, highlight your clinical rotation experience during training.</p>
          </div>

          {data.clinicalRotations.length === 0 ? (
            <div className="empty-state">
              <Icons.Clinical />
              <p>No clinical rotations added</p>
              <button className="btn btn-primary btn-sm" onClick={addClinicalRotation}>
                Add Clinical Rotation
              </button>
            </div>
          ) : (
            data.clinicalRotations.map((rot, index) => (
              <div key={rot.id} className="card-item compact">
                <div className="card-item-header">
                  <span className="card-item-number">{index + 1}</span>
                  <h4>{rot.department || `Rotation ${index + 1}`}</h4>
                  <button 
                    className="btn-icon btn-danger"
                    onClick={() => removeRotation(rot.id)}
                  >
                    <Icons.Trash />
                  </button>
                </div>
                <div className="form-grid">
                  <FormSelect
                    label="Department"
                    required
                    value={rot.department}
                    onChange={(e) => updateRotation(rot.id, 'department', e.target.value)}
                    options={CLINICAL_DEPARTMENTS}
                  />
                  <FormInput
                    label="Duration"
                    placeholder="e.g., 3 months"
                    value={rot.duration}
                    onChange={(e) => updateRotation(rot.id, 'duration', e.target.value)}
                  />
                  <FormInput
                    label="Hospital/Facility"
                    placeholder="Training Hospital"
                    value={rot.hospital}
                    onChange={(e) => updateRotation(rot.id, 'hospital', e.target.value)}
                  />
                  <FormInput
                    label="Key Learnings"
                    placeholder="Brief description"
                    value={rot.keyLearnings}
                    onChange={(e) => updateRotation(rot.id, 'keyLearnings', e.target.value)}
                  />
                </div>
              </div>
            ))
          )}
        </>
      )}
    </div>
  );
};

// ============================================
// STEP 4: CERTIFICATIONS
// ============================================

const CertificationsStep = ({ data, onChange }) => {
  const toggleCertification = (certId) => {
    const exists = data.certifications.find(c => c.id === certId);
    if (exists) {
      onChange('certifications', data.certifications.filter(c => c.id !== certId));
    } else {
      const cert = CERTIFICATIONS.find(c => c.id === certId);
      onChange('certifications', [...data.certifications, { 
        ...cert, 
        year: '', 
        issuer: '',
        certificateNumber: '' 
      }]);
    }
  };

  const updateCertDetails = (certId, field, value) => {
    onChange('certifications', data.certifications.map(c => 
      c.id === certId ? { ...c, [field]: value } : c
    ));
  };

  return (
    <div className="step-content">
      <div className="step-header">
        <div className="step-icon"><Icons.Certificate /></div>
        <div>
          <h2>Certifications</h2>
          <p>Select your professional certifications and trainings</p>
        </div>
      </div>

      <div className="certification-grid">
        {CERTIFICATIONS.map(cert => {
          const isSelected = data.certifications.some(c => c.id === cert.id);
          return (
            <div 
              key={cert.id}
              className={`certification-card ${isSelected ? 'selected' : ''}`}
              onClick={() => toggleCertification(cert.id)}
            >
              <div className="cert-icon">{cert.icon}</div>
              <span className="cert-name">{cert.name}</span>
              {isSelected && (
                <div className="cert-check">
                  <Icons.Check />
                </div>
              )}
            </div>
          );
        })}
      </div>

      {data.certifications.length > 0 && (
        <>
          <div className="section-divider">
            <span>Certification Details</span>
          </div>
          
          {data.certifications.map(cert => (
            <div key={cert.id} className="card-item compact">
              <div className="card-item-header">
                <span className="cert-badge">{cert.icon}</span>
                <h4>{cert.name}</h4>
              </div>
              <div className="form-grid cols-3">
                <FormInput
                  label="Year Obtained"
                  placeholder="2024"
                  value={cert.year}
                  onChange={(e) => updateCertDetails(cert.id, 'year', e.target.value)}
                />
                <FormInput
                  label="Issuing Authority"
                  placeholder="e.g., AHA, Indian Red Cross"
                  value={cert.issuer}
                  onChange={(e) => updateCertDetails(cert.id, 'issuer', e.target.value)}
                />
                <FormInput
                  label="Certificate Number"
                  placeholder="Certificate ID"
                  value={cert.certificateNumber}
                  onChange={(e) => updateCertDetails(cert.id, 'certificateNumber', e.target.value)}
                />
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
};

// ============================================
// STEP 5: SKILLS
// ============================================

const SkillsStep = ({ data, onChange }) => {
  const [customSkill, setCustomSkill] = useState('');

  const toggleSkill = (skill) => {
    if (data.skills.includes(skill)) {
      onChange('skills', data.skills.filter(s => s !== skill));
    } else {
      onChange('skills', [...data.skills, skill]);
    }
  };

  const addCustomSkill = () => {
    if (customSkill.trim() && !data.skills.includes(customSkill.trim())) {
      onChange('skills', [...data.skills, customSkill.trim()]);
      setCustomSkill('');
    }
  };

  const updateLanguage = (id, field, value) => {
    onChange('languages', data.languages.map(lang => 
      lang.id === id ? { ...lang, [field]: value } : lang
    ));
  };

  const addLanguage = () => {
    onChange('languages', [...data.languages, { 
      id: Date.now(), 
      name: '', 
      proficiency: 'Basic' 
    }]);
  };

  const removeLanguage = (id) => {
    if (data.languages.length > 1) {
      onChange('languages', data.languages.filter(l => l.id !== id));
    }
  };

  return (
    <div className="step-content">
      <div className="step-header">
        <div className="step-icon"><Icons.Skills /></div>
        <div>
          <h2>Skills & Languages</h2>
          <p>Highlight your nursing skills and language proficiency</p>
        </div>
      </div>

      <div className="section-title">
        <h3>🩺 Nursing Skills</h3>
        <span className="skill-count">{data.skills.length} selected</span>
      </div>

      <div className="skills-grid">
        {NURSING_SKILLS.map(skill => (
          <button 
            key={skill}
            className={`skill-chip ${data.skills.includes(skill) ? 'selected' : ''}`}
            onClick={() => toggleSkill(skill)}
          >
            {skill}
            {data.skills.includes(skill) && <Icons.Check />}
          </button>
        ))}
      </div>

      <div className="add-custom">
        <input
          type="text"
          placeholder="Add custom skill..."
          value={customSkill}
          onChange={(e) => setCustomSkill(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && addCustomSkill()}
        />
        <button className="btn btn-secondary btn-sm" onClick={addCustomSkill}>
          Add
        </button>
      </div>

      {data.skills.length > 0 && (
        <div className="selected-skills">
          <h4>Selected Skills:</h4>
          <div className="selected-skills-list">
            {data.skills.map(skill => (
              <span key={skill} className="selected-skill-tag">
                {skill}
                <button onClick={() => toggleSkill(skill)}>×</button>
              </span>
            ))}
          </div>
        </div>
      )}

      <div className="section-divider">
        <span>Languages</span>
      </div>

      <div className="languages-section">
        {data.languages.map((lang, index) => (
          <div key={lang.id} className="language-row">
            <FormInput
              label={index === 0 ? "Language" : ""}
              placeholder="Language name"
              value={lang.name}
              onChange={(e) => updateLanguage(lang.id, 'name', e.target.value)}
            />
            <FormSelect
              label={index === 0 ? "Proficiency" : ""}
              value={lang.proficiency}
              onChange={(e) => updateLanguage(lang.id, 'proficiency', e.target.value)}
              options={['Native', 'Fluent', 'Intermediate', 'Basic']}
            />
            {data.languages.length > 1 && (
              <button 
                className="btn-icon btn-danger"
                onClick={() => removeLanguage(lang.id)}
                style={{ marginTop: index === 0 ? '24px' : '0' }}
              >
                <Icons.Trash />
              </button>
            )}
          </div>
        ))}
        <button className="btn btn-link btn-sm" onClick={addLanguage}>
          + Add Language
        </button>
      </div>
    </div>
  );
};

// ============================================
// STEP 6: SUMMARY & PREVIEW
// ============================================

const SummaryStep = ({ data, onChange }) => {
  const [isGenerating, setIsGenerating] = useState(false);

  const generateAISummary = async () => {
    setIsGenerating(true);
    
    setTimeout(() => {
      const qualification = QUALIFICATIONS.find(q => q.id === data.education[0]?.qualification);
      const expYears = data.experience.length > 0 ? 
        `${data.experience.length}+ years of experience` : 
        'a recent graduate';
      
      const generatedSummary = `Dedicated and compassionate ${qualification?.name || 'Nursing'} professional with ${expYears} in healthcare settings. ${data.certifications.length > 0 ? `Certified in ${data.certifications.map(c => c.name.split('(')[0].trim()).slice(0, 3).join(', ')}.` : ''} Skilled in ${data.skills.slice(0, 5).join(', ')}. Seeking to leverage clinical expertise and patient-centered care approach to contribute to a dynamic healthcare team.`;
      
      onChange('summary', generatedSummary);
      setIsGenerating(false);
    }, 1500);
  };

  return (
    <div className="step-content">
      <div className="step-header">
        <div className="step-icon"><Icons.Sparkles /></div>
        <div>
          <h2>Professional Summary</h2>
          <p>Write or generate an impactful summary for your resume</p>
        </div>
      </div>

      <div className="ai-summary-section">
        <div className="ai-banner">
          <div className="ai-icon">🤖</div>
          <div className="ai-info">
            <h4>AI-Powered Summary Generator</h4>
            <p>Let AI write a professional summary based on your details</p>
          </div>
          <button 
            className={`btn btn-primary btn-sm ${isGenerating ? 'loading' : ''}`}
            onClick={generateAISummary}
            disabled={isGenerating}
          >
            {isGenerating ? 'Generating...' : 'Generate'}
          </button>
        </div>

        <FormTextarea
          label="Professional Summary"
          placeholder="Write a compelling 3-4 line summary highlighting your qualifications, experience, and career goals..."
          rows={5}
          value={data.summary}
          onChange={(e) => onChange('summary', e.target.value)}
        />

        <div className="summary-tips">
          <h4>💡 Tips for a Great Summary:</h4>
          <ul>
            <li>Start with your qualification and years of experience</li>
            <li>Mention your key certifications (BLS, ACLS, etc.)</li>
            <li>Highlight 2-3 core strengths or specializations</li>
            <li>End with your career goal or what you're seeking</li>
          </ul>
        </div>
      </div>

      <div className="section-divider">
        <span>Choose Template</span>
      </div>

      <div className="template-selection">
        {[
          { id: 'professional', name: 'Professional', desc: 'Modern & Clean', icon: '💼' },
          { id: 'clinical', name: 'Clinical', desc: 'Healthcare Theme', icon: '🏥' },
          { id: 'government', name: 'Government', desc: 'Formal CV Style', icon: '🏛️' },
        ].map(template => (
          <div 
            key={template.id}
            className={`template-card ${data.template === template.id ? 'selected' : ''}`}
            onClick={() => onChange('template', template.id)}
          >
            <div className="template-icon">{template.icon}</div>
            <h4>{template.name}</h4>
            <p>{template.desc}</p>
            {data.template === template.id && (
              <div className="template-check"><Icons.Check /></div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

// ============================================
// RESUME PREVIEW COMPONENT - DISTINCT TEMPLATES
// ============================================

const ResumePreview = ({ data }) => {
  const qualification = QUALIFICATIONS.find(q => q.id === data.education[0]?.qualification);
  
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-IN', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  // Professional Template
  if (data.template === 'professional') {
    return (
      <div className="resume-preview" id="resume-preview">
        <div className="resume-paper template-professional">
          <header className="resume-header-pro">
            <div className="resume-header-left">
              {data.personal.photo && (
                <div className="resume-photo-pro">
                  <img src={data.personal.photo} alt="Profile" />
                </div>
              )}
              <div className="resume-title-pro">
                <h1>{data.personal.fullName || 'Your Name'}</h1>
                <p className="resume-subtitle-pro">
                  {qualification?.name || 'Nursing Professional'}
                </p>
              </div>
            </div>
            <div className="resume-contact-pro">
              {data.personal.phone && <div className="contact-item">📞 {data.personal.phone}</div>}
              {data.personal.email && <div className="contact-item">✉️ {data.personal.email}</div>}
              {data.personal.city && <div className="contact-item">📍 {data.personal.city}, {data.personal.state}</div>}
            </div>
          </header>

          {data.summary && (
            <section className="resume-section-pro">
              <h2 className="section-heading-pro">
                <span className="heading-icon">👤</span> Professional Summary
              </h2>
              <p className="summary-text-pro">{data.summary}</p>
            </section>
          )}

          <div className="resume-columns">
            <div className="resume-main">
              {data.experience.length > 0 && (
                <section className="resume-section-pro">
                  <h2 className="section-heading-pro">
                    <span className="heading-icon">💼</span> Work Experience
                  </h2>
                  {data.experience.map((exp, index) => (
                    <div key={index} className="experience-item-pro">
                      <div className="exp-header">
                        <h3>{exp.designation}</h3>
                        <span className="exp-date">{formatDate(exp.startDate)} - {exp.currentlyWorking ? 'Present' : formatDate(exp.endDate)}</span>
                      </div>
                      <p className="exp-company">{exp.hospitalName} • {exp.department}</p>
                      {exp.responsibilities && <p className="exp-desc">{exp.responsibilities}</p>}
                    </div>
                  ))}
                </section>
              )}

              {data.clinicalRotations.length > 0 && (
                <section className="resume-section-pro">
                  <h2 className="section-heading-pro">
                    <span className="heading-icon">🩺</span> Clinical Rotations
                  </h2>
                  <div className="rotations-list">
                    {data.clinicalRotations.map((rot, index) => (
                      <div key={index} className="rotation-item-pro">
                        <strong>{rot.department}</strong> - {rot.duration}
                        {rot.hospital && <span className="rotation-hospital"> at {rot.hospital}</span>}
                      </div>
                    ))}
                  </div>
                </section>
              )}

              {data.education.some(e => e.qualification) && (
                <section className="resume-section-pro">
                  <h2 className="section-heading-pro">
                    <span className="heading-icon">🎓</span> Education
                  </h2>
                  {data.education.filter(e => e.qualification).map((edu, index) => {
                    const qual = QUALIFICATIONS.find(q => q.id === edu.qualification);
                    return (
                      <div key={index} className="education-item-pro">
                        <h3>{qual?.name}</h3>
                        <p>{edu.institution} • {edu.year}</p>
                        {edu.percentage && <p className="edu-score">Score: {edu.percentage}</p>}
                      </div>
                    );
                  })}
                </section>
              )}
            </div>

            <div className="resume-sidebar">
              {data.registration.registrationNumber && (
                <section className="sidebar-section">
                  <h3 className="sidebar-heading">🏛️ Registration</h3>
                  <div className="registration-info">
                    <p><strong>{data.registration.councilState}</strong></p>
                    <p>Reg: {data.registration.registrationNumber}</p>
                    {data.registration.validTill && <p>Valid: {formatDate(data.registration.validTill)}</p>}
                  </div>
                </section>
              )}

              {data.certifications.length > 0 && (
                <section className="sidebar-section">
                  <h3 className="sidebar-heading">📜 Certifications</h3>
                  <div className="cert-list-pro">
                    {data.certifications.map((cert, index) => (
                      <div key={index} className="cert-item-pro">
                        <span className="cert-icon-pro">{cert.icon}</span>
                        <span>{cert.name.split('(')[0].trim()}</span>
                      </div>
                    ))}
                  </div>
                </section>
              )}

              {data.skills.length > 0 && (
                <section className="sidebar-section">
                  <h3 className="sidebar-heading">💪 Skills</h3>
                  <div className="skills-list-pro">
                    {data.skills.slice(0, 10).map((skill, index) => (
                      <span key={index} className="skill-tag-pro">{skill}</span>
                    ))}
                  </div>
                </section>
              )}

              {data.languages.some(l => l.name) && (
                <section className="sidebar-section">
                  <h3 className="sidebar-heading">🌐 Languages</h3>
                  <div className="languages-list-pro">
                    {data.languages.filter(l => l.name).map((lang, index) => (
                      <div key={index} className="lang-item-pro">
                        {lang.name} <small>({lang.proficiency})</small>
                      </div>
                    ))}
                  </div>
                </section>
              )}
            </div>
          </div>

          <footer className="resume-footer-pro">
            Generated by NurseResume • AutoHireBot.com
          </footer>
        </div>
      </div>
    );
  }

  // Clinical Template
  if (data.template === 'clinical') {
    return (
      <div className="resume-preview" id="resume-preview">
        <div className="resume-paper template-clinical">
          <div className="clinical-header">
            <div className="clinical-header-bg"></div>
            <div className="clinical-header-content">
              {data.personal.photo && (
                <div className="clinical-photo">
                  <img src={data.personal.photo} alt="Profile" />
                </div>
              )}
              <div className="clinical-title">
                <h1>{data.personal.fullName || 'Your Name'}</h1>
                <p className="clinical-subtitle">{qualification?.name || 'Nursing Professional'}</p>
                <div className="clinical-contact">
                  {data.personal.phone && <span>📞 {data.personal.phone}</span>}
                  {data.personal.email && <span>✉️ {data.personal.email}</span>}
                  {data.personal.city && <span>📍 {data.personal.city}</span>}
                </div>
              </div>
            </div>
          </div>

          {data.registration.registrationNumber && (
            <div className="clinical-registration">
              <span className="reg-label">Nursing Council Registration:</span>
              <span className="reg-value">{data.registration.councilState} - {data.registration.registrationNumber}</span>
            </div>
          )}

          <div className="clinical-body">
            {data.summary && (
              <section className="clinical-section">
                <h2><span className="clinical-icon">🏥</span> About Me</h2>
                <p>{data.summary}</p>
              </section>
            )}

            {data.certifications.length > 0 && (
              <section className="clinical-section">
                <h2><span className="clinical-icon">❤️</span> Certifications</h2>
                <div className="clinical-certs">
                  {data.certifications.map((cert, index) => (
                    <div key={index} className="clinical-cert-card">
                      <span className="cert-emoji">{cert.icon}</span>
                      <span className="cert-text">{cert.name}</span>
                      {cert.year && <span className="cert-year">{cert.year}</span>}
                    </div>
                  ))}
                </div>
              </section>
            )}

            {(data.experience.length > 0 || data.clinicalRotations.length > 0) && (
              <section className="clinical-section">
                <h2><span className="clinical-icon">💼</span> Clinical Experience</h2>
                {data.experience.map((exp, index) => (
                  <div key={index} className="clinical-exp">
                    <div className="clinical-exp-dot"></div>
                    <div className="clinical-exp-content">
                      <h3>{exp.designation}</h3>
                      <p className="clinical-exp-place">{exp.hospitalName} • {exp.department}</p>
                      <p className="clinical-exp-date">{formatDate(exp.startDate)} - {exp.currentlyWorking ? 'Present' : formatDate(exp.endDate)}</p>
                    </div>
                  </div>
                ))}
                {data.clinicalRotations.map((rot, index) => (
                  <div key={index} className="clinical-exp">
                    <div className="clinical-exp-dot rotation"></div>
                    <div className="clinical-exp-content">
                      <h3>{rot.department}</h3>
                      <p className="clinical-exp-place">{rot.hospital} • {rot.duration}</p>
                    </div>
                  </div>
                ))}
              </section>
            )}

            <div className="clinical-grid">
              <section className="clinical-section">
                <h2><span className="clinical-icon">🎓</span> Education</h2>
                {data.education.filter(e => e.qualification).map((edu, index) => {
                  const qual = QUALIFICATIONS.find(q => q.id === edu.qualification);
                  return (
                    <div key={index} className="clinical-edu">
                      <h3>{qual?.name}</h3>
                      <p>{edu.institution}</p>
                      <p className="edu-meta">{edu.year} {edu.percentage && `• ${edu.percentage}`}</p>
                    </div>
                  );
                })}
              </section>

              <section className="clinical-section">
                <h2><span className="clinical-icon">💪</span> Skills</h2>
                <div className="clinical-skills">
                  {data.skills.map((skill, index) => (
                    <span key={index} className="clinical-skill">{skill}</span>
                  ))}
                </div>
              </section>
            </div>
          </div>

          <footer className="clinical-footer">
            <span>NurseResume by AutoHireBot</span>
          </footer>
        </div>
      </div>
    );
  }

  // Government Template
  return (
    <div className="resume-preview" id="resume-preview">
      <div className="resume-paper template-government">
        <header className="govt-header">
          <h1>CURRICULUM VITAE</h1>
        </header>

        <div className="govt-photo-section">
          {data.personal.photo && (
            <div className="govt-photo">
              <img src={data.personal.photo} alt="Profile" />
            </div>
          )}
        </div>

        <section className="govt-section">
          <h2>PERSONAL DETAILS</h2>
          <table className="govt-table">
            <tbody>
              <tr>
                <td className="label">Name</td>
                <td className="value">{data.personal.fullName || '-'}</td>
              </tr>
              <tr>
                <td className="label">Date of Birth</td>
                <td className="value">{formatDate(data.personal.dateOfBirth) || '-'}</td>
              </tr>
              <tr>
                <td className="label">Gender</td>
                <td className="value">{data.personal.gender || '-'}</td>
              </tr>
              <tr>
                <td className="label">Marital Status</td>
                <td className="value">{data.personal.maritalStatus || '-'}</td>
              </tr>
              <tr>
                <td className="label">Contact Number</td>
                <td className="value">{data.personal.phone || '-'}</td>
              </tr>
              <tr>
                <td className="label">Email</td>
                <td className="value">{data.personal.email || '-'}</td>
              </tr>
              <tr>
                <td className="label">Address</td>
                <td className="value">{data.personal.address ? `${data.personal.address}, ${data.personal.city}, ${data.personal.state} - ${data.personal.pincode}` : '-'}</td>
              </tr>
            </tbody>
          </table>
        </section>

        {data.registration.registrationNumber && (
          <section className="govt-section">
            <h2>PROFESSIONAL REGISTRATION</h2>
            <table className="govt-table">
              <tbody>
                <tr>
                  <td className="label">Nursing Council</td>
                  <td className="value">{data.registration.councilState} Nursing Council</td>
                </tr>
                <tr>
                  <td className="label">Registration Number</td>
                  <td className="value">{data.registration.registrationNumber}</td>
                </tr>
                <tr>
                  <td className="label">Valid From</td>
                  <td className="value">{formatDate(data.registration.validFrom) || '-'}</td>
                </tr>
                <tr>
                  <td className="label">Valid Till</td>
                  <td className="value">{formatDate(data.registration.validTill) || '-'}</td>
                </tr>
              </tbody>
            </table>
          </section>
        )}

        <section className="govt-section">
          <h2>EDUCATIONAL QUALIFICATIONS</h2>
          <table className="govt-table bordered">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Qualification</th>
                <th>Institution</th>
                <th>Year</th>
                <th>Marks/Grade</th>
              </tr>
            </thead>
            <tbody>
              {data.education.filter(e => e.qualification).map((edu, index) => {
                const qual = QUALIFICATIONS.find(q => q.id === edu.qualification);
                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{qual?.name}</td>
                    <td>{edu.institution}</td>
                    <td>{edu.year}</td>
                    <td>{edu.percentage || '-'}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </section>

        {data.experience.length > 0 && (
          <section className="govt-section">
            <h2>WORK EXPERIENCE</h2>
            <table className="govt-table bordered">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Designation</th>
                  <th>Organization</th>
                  <th>Department</th>
                  <th>Period</th>
                </tr>
              </thead>
              <tbody>
                {data.experience.map((exp, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{exp.designation}</td>
                    <td>{exp.hospitalName}</td>
                    <td>{exp.department}</td>
                    <td>{formatDate(exp.startDate)} to {exp.currentlyWorking ? 'Present' : formatDate(exp.endDate)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>
        )}

        {data.certifications.length > 0 && (
          <section className="govt-section">
            <h2>CERTIFICATIONS</h2>
            <table className="govt-table bordered">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Certification</th>
                  <th>Year</th>
                  <th>Issuing Authority</th>
                </tr>
              </thead>
              <tbody>
                {data.certifications.map((cert, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{cert.name}</td>
                    <td>{cert.year || '-'}</td>
                    <td>{cert.issuer || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>
        )}

        {data.skills.length > 0 && (
          <section className="govt-section">
            <h2>SKILLS</h2>
            <p className="govt-skills">{data.skills.join(', ')}</p>
          </section>
        )}

        {data.languages.some(l => l.name) && (
          <section className="govt-section">
            <h2>LANGUAGES KNOWN</h2>
            <p className="govt-skills">
              {data.languages.filter(l => l.name).map(l => `${l.name} (${l.proficiency})`).join(', ')}
            </p>
          </section>
        )}

        <section className="govt-section">
          <h2>DECLARATION</h2>
          <p className="govt-declaration">
            I hereby declare that all the information provided above is true and correct to the best of my knowledge and belief.
          </p>
          <div className="govt-signature">
            <div className="signature-line">
              <p>Place: ________________</p>
              <p>Date: ________________</p>
            </div>
            <div className="signature-box">
              <p>Signature</p>
              <p>({data.personal.fullName || 'Candidate Name'})</p>
            </div>
          </div>
        </section>

        <footer className="govt-footer">
          Generated using NurseResume by AutoHireBot
        </footer>
      </div>
    </div>
  );
};

// ============================================
// MAIN APP COMPONENT
// ============================================

export default function NurseResumeBuilder() {
  const [currentStep, setCurrentStep] = useState(0);
  const [resumeData, setResumeData] = useState(initialResumeData);
  const [showPreview, setShowPreview] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  const steps = [
    { id: 'personal', label: 'Personal', icon: Icons.User },
    { id: 'education', label: 'Education', icon: Icons.Education },
    { id: 'experience', label: 'Experience', icon: Icons.Briefcase },
    { id: 'certifications', label: 'Certifications', icon: Icons.Certificate },
    { id: 'skills', label: 'Skills', icon: Icons.Skills },
    { id: 'summary', label: 'Summary', icon: Icons.Sparkles },
  ];

  const handleDataChange = (section, value) => {
    setResumeData(prev => ({ ...prev, [section]: value }));
  };

  const nextStep = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const downloadPDF = async () => {
    setIsDownloading(true);
    
    // Show preview first if not visible
    if (!showPreview) {
      setShowPreview(true);
      // Wait for preview to render
      await new Promise(resolve => setTimeout(resolve, 500));
    }
    
    const element = document.querySelector('.resume-paper');
    
    if (!element) {
      alert('Please click Preview first to generate your resume, then click Download.');
      setIsDownloading(false);
      return;
    }

    // Check if html2pdf is already loaded
    if (window.html2pdf) {
      generatePDF(element);
    } else {
      // Load html2pdf dynamically
      const script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js';
      script.onload = () => generatePDF(element);
      script.onerror = () => {
        alert('Failed to load PDF library. Please try again.');
        setIsDownloading(false);
      };
      document.head.appendChild(script);
    }
  };

  const generatePDF = (element) => {
    const opt = {
      margin: [5, 5, 5, 5],
      filename: `${resumeData.personal.fullName || 'NurseResume'}_Resume.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { 
        scale: 2, 
        useCORS: true,
        logging: false,
        letterRendering: true
      },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
    };
    
    window.html2pdf()
      .set(opt)
      .from(element)
      .save()
      .then(() => {
        setIsDownloading(false);
      })
      .catch((err) => {
        console.error('PDF Error:', err);
        alert('PDF generation failed. Please try printing instead (Ctrl+P).');
        setIsDownloading(false);
      });
  };

  const renderStep = () => {
    switch (currentStep) {
      case 0: return <PersonalInfoStep data={resumeData} onChange={handleDataChange} />;
      case 1: return <EducationStep data={resumeData} onChange={handleDataChange} />;
      case 2: return <ExperienceStep data={resumeData} onChange={handleDataChange} />;
      case 3: return <CertificationsStep data={resumeData} onChange={handleDataChange} />;
      case 4: return <SkillsStep data={resumeData} onChange={handleDataChange} />;
      case 5: return <SummaryStep data={resumeData} onChange={handleDataChange} />;
      default: return null;
    }
  };

  return (
    <div className="nurse-resume-app">
      <header className="app-header">
        <div className="header-brand">
          <span className="brand-icon">🏥</span>
          <div>
            <h1>NurseResume</h1>
            <span className="brand-tagline">by AutoHireBot</span>
          </div>
        </div>
        <div className="header-actions">
          <button 
            className="btn btn-outline btn-sm"
            onClick={() => setShowPreview(!showPreview)}
          >
            <Icons.Eye /> {showPreview ? 'Hide' : 'Preview'}
          </button>
          <button 
            className={`btn btn-primary btn-sm ${isDownloading ? 'loading' : ''}`} 
            onClick={downloadPDF}
            disabled={isDownloading}
          >
            <Icons.Download /> {isDownloading ? 'Downloading...' : 'Download PDF'}
          </button>
        </div>
      </header>

      <main className="app-main">
        <div className={`form-panel ${showPreview ? 'with-preview' : ''}`}>
          <StepIndicator 
            currentStep={currentStep} 
            steps={steps} 
            onStepClick={setCurrentStep}
          />
          
          <div className="form-content">
            {renderStep()}
          </div>

          <div className="form-navigation">
            <button 
              className="btn btn-nav"
              onClick={prevStep}
              disabled={currentStep === 0}
            >
              <Icons.ArrowLeft /> Prev
            </button>
            
            <div className="step-counter">
              {currentStep + 1} / {steps.length}
            </div>
            
            {currentStep < steps.length - 1 ? (
              <button className="btn btn-nav btn-nav-primary" onClick={nextStep}>
                Next <Icons.ArrowRight />
              </button>
            ) : (
              <button 
                className={`btn btn-nav btn-nav-success ${isDownloading ? 'loading' : ''}`} 
                onClick={downloadPDF}
                disabled={isDownloading}
              >
                <Icons.Download /> Download
              </button>
            )}
          </div>
        </div>

        {showPreview && (
          <div className="preview-panel">
            <div className="preview-header">
              <h3>📄 Live Preview</h3>
              <span className="preview-badge">Real-time</span>
            </div>
            <ResumePreview data={resumeData} />
          </div>
        )}
      </main>

      <footer className="app-footer">
        Made with ❤️ for Nursing Professionals | <a href="https://autohirebot.com" target="_blank" rel="noopener noreferrer">AutoHireBot.com</a>
      </footer>
    </div>
  );
}
